import React from "react";
import { ExternalLink, Server, Edit2, Trash2 } from "lucide-react";
import { getCondoRedirectUrl } from "../../../utils/authRedirect";

export default function CondominiosGrid({
  condominios,
  loading,
  error,
  onEdit,
  onDelete,
}) {
  if (loading) {
    return <div className="condo-grid-state">Carregando condomínios...</div>;
  }

  if (error) {
    return (
      <div className="condo-grid-state condo-grid-state-error">{error}</div>
    );
  }

  if (!condominios.length) {
    return <div className="condo-grid-state">Nenhum condomínio cadastrado.</div>;
  }

  return (
    <div className="condo-grid">
      {condominios.map((c) => {
        const url = getCondoRedirectUrl(c?.app_url, c?.id);

        return (
          <article key={c.id} className="condo-card">
            <header className="condo-card-header">
              <div className="condo-avatar">{c.name?.[0]?.toUpperCase() ?? "?"}</div>
              <div>
                <h2 className="condo-card-title">{c.name}</h2>
                <p className="condo-card-subtitle">ID #{c.id}</p>
              </div>
            </header>

            <div className="condo-card-body">
              <div className="condo-card-row">
                <span className="condo-label">Domínio</span>

                <a
                  href={url || "#"}
                  target="_blank"
                  rel="noreferrer"
                  className="condo-link"
                  title={c.app_url}
                  onClick={(e) => {
                    if (!url) {
                      e.preventDefault();
                      alert("Token ausente. Faça login novamente.");
                    }
                  }}
                >
                  <ExternalLink size={16} />
                  <span>{truncate(c.app_url, 35)}</span>
                </a>
              </div>

              <div className="condo-card-row">
                <span className="condo-label">Server</span>

                {c.server_url ? (
                  <span className="condo-chip">
                    <Server size={14} />
                    <span>{truncate(c.server_url, 28)}</span>
                  </span>
                ) : (
                  <span className="condo-chip condo-chip-muted">
                    <Server size={14} />
                    <span>Sem server</span>
                  </span>
                )}
              </div>
            </div>

            <footer className="condo-card-footer">
              <button
                type="button"
                className="condo-btn condo-btn-secondary"
                onClick={() => onEdit(c)}
              >
                <Edit2 size={16} />
                <span>Editar</span>
              </button>

              <button
                type="button"
                className="condo-btn condo-btn-danger"
                onClick={() => onDelete(c)}
              >
                <Trash2 size={16} />
                <span>Excluir</span>
              </button>
            </footer>
          </article>
        );
      })}
    </div>
  );
}

function truncate(text, max) {
  if (!text) return "";
  return text.length > max ? text.slice(0, max - 1) + "…" : text;
}
